




























import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import ConfettiGenerator from 'confetti-js';
import Modal from '@/components/common/Modal/Modal.vue';
import QrIcon from './images/qr.vue.svg';
import ButtonIcon from './images/button.vue.svg';
import CloseIcon from './images/close.vue.svg';
import { LINK_TO_MOBILE_APP } from '~/constants/common';

type ConfettiInstance = {
  render: () => void;
  clear: () => void;
};

@Component({
  name: 'HeaderDirectMessagesPromo',
  components: {
    Modal,
    QrIcon,
    ButtonIcon,
    CloseIcon,
  },
})
export default class HeaderDirectMessagesPromo extends Vue {
  $refs!: {
    vue: Vue;
    element: HTMLInputElement;
    vues: Vue[];
    elements: HTMLInputElement[];
    confetti: HTMLCanvasElement;
  };

  link: string = LINK_TO_MOBILE_APP;
  instance?: ConfettiInstance;

  handleOpen() {
    if (process.server) return;
    this.$nextTick(() => {
      const canvas = this.$refs.confetti;
      // https://sentry.io/organizations/bravado-network/issues/3526631095/?project=5952605&query=is%3Aunresolved&referrer=issue-stream&statsPeriod=14d
      if (canvas) {
        this.instance = new ConfettiGenerator({
          target: canvas,
          max: 100,
          size: 0.5,
          props: ['square', 'triangle'],
          clock: 7,
          width: canvas.width,
          height: canvas.height,
          start_from_edge: true,
          respawn: true,
          rotate: true,
        }) as ConfettiInstance;
        this.instance.render();
      }
    });
  }

  handleClose() {
    this.instance?.clear();
  }
}
